// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"54":"555158dd","208":"111cc92c","631":"72b47a58","760":"8a6643d1","774":"0eb4bf0b","787":"c1029864","820":"85de7c57","910":"9eb5a46b"}[chunkId] + ".chunk.js";
};